import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getSummary(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_DASHBOARD_SUMMARY_REQUEST,
			payload: { loadingSummary: true }
		});

		const response = await API.dashboard.getSummary(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_DASHBOARD_SUMMARY_ERROR,
				payload: { meta: response.meta, loadingSummary: false }
			});
			return;
		}

		dispatch({
			type: ActionTypes.GET_DASHBOARD_SUMMARY_SUCCESS,
			payload: {
				summary: response.data,
				loadingSummary: false
			}
		});
	};
}

export function getOvertime(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_DASHBOARD_OVERTIME_REQUEST,
			payload: { loadingOvertime: true }
		});

		const response = await API.dashboard.getOvertime(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_DASHBOARD_OVERTIME_ERROR,
				payload: { meta: response.meta, loadingOvertime: false }
			});
			return;
		}

		dispatch({
			type: ActionTypes.GET_DASHBOARD_OVERTIME_SUCCESS,
			payload: {
				overtime: response.data,
				loadingOvertime: false
			}
		});
	};
}

export function getByChannel(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_DASHBOARD_BY_CHANNEL_REQUEST,
			payload: { loadingByChannel: true }
		});

		const response = await API.dashboard.getByChannel(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_DASHBOARD_BY_CHANNEL_ERROR,
				payload: { meta: response.meta, loadingByChannel: false }
			});
			return;
		}

		dispatch({
			type: ActionTypes.GET_DASHBOARD_BY_CHANNEL_SUCCESS,
			payload: {
				byChannel: response.data,
				loadingByChannel: false
			}
		});
	};
}

export function getByCategory(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_DASHBOARD_BY_CATEGORY_REQUEST,
			payload: { loadingByCategory: true }
		});

		const response = await API.dashboard.getByCategory(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_DASHBOARD_BY_CATEGORY_ERROR,
				payload: { meta: response.meta, loadingByCategory: false }
			});
			return;
		}

		dispatch({
			type: ActionTypes.GET_DASHBOARD_BY_CATEGORY_SUCCESS,
			payload: {
				byCategory: response.data,
				loadingByCategory: false
			}
		});
	};
}

export function getByPaymentMethod(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_DASHBOARD_BY_PAYMENT_METHOD_REQUEST,
			payload: { loadingByPaymentMethod: true }
		});

		const response = await API.dashboard.getByPaymentMethod(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_DASHBOARD_BY_PAYMENT_METHOD_ERROR,
				payload: { meta: response.meta, loadingByPaymentMethod: false }
			});
			return;
		}

		dispatch({
			type: ActionTypes.GET_DASHBOARD_BY_PAYMENT_METHOD_SUCCESS,
			payload: {
				byPaymentMethod: response.data,
				loadingByPaymentMethod: false
			}
		});
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({ type: ActionTypes.RESET_DASHBOARD_META });
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({ type: ActionTypes.RESET_DASHBOARD_PAGE });
	};
}
